import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api, formatKES } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { FileSignature, CheckCircle2, Clock, ArrowRight } from "lucide-react";

export default function ContractsList() {
  const [contracts, setContracts] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/contracts").then((r) => setContracts(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FE]">
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-10">
        <div className="label-eyebrow mb-2">Contracts</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">My Contracts</h1>
        <p className="text-[#5B6478] mt-2 max-w-2xl">
          Kenya-compliant engagement contracts drafted by KSB. Both parties must sign electronically before placement becomes active.
        </p>

        <div className="mt-8 space-y-3">
          {contracts.length === 0 && (
            <div className="text-center py-16 border border-dashed border-[#E4E7F5] rounded-md text-[#5B6478]">
              <FileSignature className="w-10 h-10 mx-auto mb-3 opacity-40" />
              <div>No contracts yet. Once you're matched, KSB will draft one for signature.</div>
            </div>
          )}
          {contracts.map((c) => (
            <button
              key={c.id}
              onClick={() => nav(`/contracts/${c.id}`)}
              data-testid={`contract-row-${c.id}`}
              className="w-full text-left bg-white border border-[#E4E7F5] rounded-md p-5 flex items-center justify-between hover:shadow-sm transition-shadow"
            >
              <div>
                <div className="font-display font-semibold">{c.role_title}</div>
                <div className="text-sm text-[#5B6478] mt-1">
                  {c.employee_name} ↔ {c.customer_name} · starts {c.start_date}
                </div>
                <div className="text-sm text-[#1E3A8A] font-semibold mt-1">
                  {formatKES(c.salary_agreed)} / {c.pay_frequency}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex flex-col gap-1 text-xs">
                  <span className="flex items-center gap-1">
                    {c.customer_signed ? <CheckCircle2 className="w-3 h-3 text-[#1E3A8A]" /> : <Clock className="w-3 h-3 text-amber-600" />}
                    Employer
                  </span>
                  <span className="flex items-center gap-1">
                    {c.employee_signed ? <CheckCircle2 className="w-3 h-3 text-[#1E3A8A]" /> : <Clock className="w-3 h-3 text-amber-600" />}
                    Staff
                  </span>
                </div>
                <Badge className={`capitalize ${c.status === "active" ? "bg-[#1E3A8A]" : c.status === "terminated" ? "bg-[#B91C1C]" : "bg-amber-100 text-amber-900 hover:bg-amber-100"}`}>
                  {c.status?.replace("_", " ")}
                </Badge>
                <ArrowRight className="w-4 h-4 text-[#5B6478]" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
